"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RarityFilter = void 0;
const react_1 = __importDefault(require("react"));
const schemas_1 = require("@dcl/schemas");
const RarityFilter_1 = require("decentraland-ui/dist/components/RarityFilter");
const utils_1 = require("../../modules/translation/utils");
const RarityFilter = (props) => {
    const i18n = {
        rarities: {
            [schemas_1.Rarity.UNIQUE]: (0, utils_1.t)('@dapps.rarities.unique'),
            [schemas_1.Rarity.MYTHIC]: (0, utils_1.t)('@dapps.rarities.mythic'),
            [schemas_1.Rarity.LEGENDARY]: (0, utils_1.t)('@dapps.rarities.legendary'),
            [schemas_1.Rarity.EPIC]: (0, utils_1.t)('@dapps.rarities.epic'),
            [schemas_1.Rarity.RARE]: (0, utils_1.t)('@dapps.rarities.rare'),
            [schemas_1.Rarity.UNCOMMON]: (0, utils_1.t)('@dapps.rarities.uncommon'),
            [schemas_1.Rarity.COMMON]: (0, utils_1.t)('@dapps.rarities.common')
        },
        title: (0, utils_1.t)('@dapps.rarities_filter.title'),
        all_rarities: (0, utils_1.t)('@dapps.rarities_filter.all_rarities'),
        count_rarities: (count) => (0, utils_1.t)('@dapps.rarities_filter.count_rarities', { count: count }),
        tooltip: (0, utils_1.t)('@dapps.rarities_filter.tooltip')
    };
    return react_1.default.createElement(RarityFilter_1.RarityFilter, Object.assign({ i18n: i18n }, props));
};
exports.RarityFilter = RarityFilter;
//# sourceMappingURL=RarityFilter.js.map